import {
  Avatar,
  Col,
  DatePicker,
  Flex,
  Input,
  message,
  Row,
  Space,
  Table,
  Typography,
  Badge,
  Select,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { IconRight, IconSearch } from "../../../assets/icons";
import dayjs from "dayjs";
import { Route, Routes, useNavigate } from "react-router-dom";
import api from "../../../api/api";
import _ from "lodash";
import { getFormattedNumber } from "@utils";
import Details from "../../DataManagement/UserManagement/Details/Details";
import { UserOutlined } from "@ant-design/icons";
import { useAtom } from "jotai";
import { savedUserReportTablePage } from "../../../utils/atom";
import moment from "moment";
import { useTranslation } from "react-i18next";

const RootContainer = styled.div`
  .ant-table svg {
    cursor: pointer;
  }
`;

const Title = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
`;

const Card = styled.div`
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  justify-content: center;
  background: ${(props) => props.theme.backgroundColor};
`;

const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #1d1014;
`;

const BoldText = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1d1014;
`;

const { RangePicker } = DatePicker;

const UserReport = () => {
  const [savedUserReportPage,setSavedUserReportPage] = useAtom(savedUserReportTablePage);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState({});
  const [data, setData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [dateFilterType, setDateFilterType] = useState("all");
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);
  const [pagination, setPagination] = useState({
    current: savedUserReportPage ?? 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  }, []);

  useEffect(() => {
    getUsers();
  }, [keyword, pagination.current, pagination.pageSize, dateRange,dateFilterType]);

  const {t} = useTranslation();

  // const getUsers = () => {
  //   setLoading(true);
  //   setData([]);

  //   // Ensure we have valid dates
  //   if (
  //     !dateRange ||
  //     dateRange.length !== 2 ||
  //     !dateRange[0] ||
  //     !dateRange[1]
  //   ) {
  //     console.error("Invalid date range:", dateRange);
  //     setLoading(false);
  //     return;
  //   }

  //   const [fromDate, toDate] = dateRange;

  //   // Debug: Log the dates being sent
  //   console.log("Date range being sent:", {
  //     from: dayjs(fromDate).format("YYYY-MM-DD"),
  //     to: dayjs(toDate).format("YYYY-MM-DD"),
  //     keyword,
  //     page: pagination.current,
  //     limit: pagination.pageSize,
  //   });

  //   api
  //     .getUsers({
  //       keyword,
  //       page: pagination.current,
  //       limit: pagination.pageSize,
  //       from: dayjs(fromDate).format("YYYY-MM-DD"),
  //       to: dayjs(toDate).format("YYYY-MM-DD"),
  //     })
  //     .then(({ data, totalUsers, todayUsers }) => {
  //       setLoading(false);
  //       setData(data);

  //       // Update counts and pagination
        // setCounts({ totalUsers, todayUsers });
  //       setPagination((prev) => ({
  //         ...prev,
  //         total: totalUsers,
  //       }));
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       message.error(error || "Failed to fetch users");
  //     });
  // };

  const getUsers = () => {
    setLoading(true);
    setData([]);

    let from = "";
    let to = "";

    if (dateFilterType === "date" && dateRange && dateRange.length === 2) {
      from = dayjs(dateRange[0]).format("YYYY-MM-DD");
      to = dayjs(dateRange[1]).format("YYYY-MM-DD");
    }

    api
      .getUsers({
        keyword,
        page: pagination.current,
        limit: pagination.pageSize,
        from,
        to,
      })
      .then(({ data, totalUsers, todayUsers }) => {
        setLoading(false);
        setData(data);
        setCounts({ totalUsers, todayUsers });
        // setTotalUsers(totalUsers);
       setPagination((prev) => ({
          ...prev,
          total: totalUsers,
        }));
      })
      .catch((error) => {
        setLoading(false);
        message.error(error || t('fail_to_fetch_user'));
      });
  };


  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setPagination((prev) => ({ ...prev, current: 1 }));
      setDateRange(dates);
    } else {
      setDateRange(null);
    }
  };

  const debouncedResults = useMemo(() => {
    return _.debounce((e) => {
      setPagination((prev) => ({ ...prev, current: 1 }));
      setKeyword(e.target.value.trim());
    }, 1000);
  }, []);

  const goToDetails = (item) => {
    navigate(`details/${item.id}`);
    setSavedUserReportPage(pagination?.current)
  };

  // const handleDateChange = (dates) => {
  //   // console.log("Date picker changed:", dates); // Debug log

  //   if (dates && dates.length === 2) {
  //     // Reset pagination to first page when date changes
  //     setPagination((prev) => ({ ...prev, current: 1 }));
  //     setDateRange(dates);
  //   }
  // };

  const handleTableChange = (newPagination) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }));
  };

  const columns = [
    {
      key: "key",
      title: t('no.'),
      render: (_, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      key: "name",
      dataIndex: "name",
      title: t('customers'),
      width: "28%",
      render: (_, record) => (
        <Space>
          <Avatar
            shape={"square"}
            size={32}
            src={record.social_profile || record.profile_url}
            icon={!record.social_profile && !record.profile_url ? <UserOutlined style={{fontSize:"16px"}} /> : undefined}
          />
          <Flex style={{gap:"0px",flexDirection:"column",justifyContent:"start",alignItems:"start"}}>
            <Typography>{record?.custom_name}</Typography>
            <Typography>{record?.username}</Typography>
          </Flex>
        </Space>
      ),
    },
     {
      key: "username",
      dataIndex: "username",
      title: t('join_on'),
      width: "28%",
      render: (_, record) => (
        <Typography>
          {moment(record?.created_at).format("DD MMM YYYY, HH:mm")}
        </Typography>
      )
    },
    {
      key: "status",
      dataIndex: "status",
      title: t('status'),
      // filters: statusFilter,
      onFilter: (value, record) => record.status === value,
      render: (_, record) =>
        record.status ? (
          <Badge status="success" text="Active" />
        ) : (
          <Badge status="error" text="Blocked" />
        ),
    },
    {
      key: "actions",
      title: t('actions'),
      render: (_, record) => (
        <Space>
          <IconRight onClick={() => goToDetails(record)} />
        </Space>
      ),
    },
  ];

  return (
    <RootContainer>
      <Title>{t('customer_report')}</Title>
      <Row gutter={[24, 24]}>
        <Col xs={12}>
          <Card>
            <Text>{t('total_customer')}</Text>
            <BoldText>
              {loading ? "..." : getFormattedNumber(counts.totalUsers || 0)}
            </BoldText>
          </Card>
        </Col>
        <Col xs={12}>
          <Card>
            <Text>{t('today_customer')}</Text>
            <BoldText>
              {loading ? "..." : getFormattedNumber(counts.todayUsers || 0)}
            </BoldText>
          </Card>
        </Col>

        {/* Search and Date Range Controls */}
        <Col xs={24} sm={12} lg={10}>
         <Flex style={{gap:"20px"}}>
          <Input
            placeholder={t('search_customer_id_name')}
            prefix={<IconSearch />}
            onChange={debouncedResults}
            allowClear
          />
        <Select
              style={{ width: 300}}
              value={dateFilterType}
              onChange={(value) => {
                setDateFilterType(value);
                setDateRange(null);
              }}
              options={[
                { value: "all", label: t('all_time') },
                { value: "date", label: t('date') },
              ]}
            />
        </Flex>
         </Col>
        <Col xs={0} lg={6}></Col>
        <Col xs={24} sm={12} lg={8}>
          {/* <RangePicker
            style={{ width: "100%", height: "48px" }}
            value={dateRange}
            onChange={handleDateChange}
            allowClear={false}
            format="D MMM, YYYY"
            placement="bottomLeft"
          /> */}
          {dateFilterType === "date" && (
              <RangePicker
                style={{ width: "100%", height: "48px" }}
                value={dateRange}
                onChange={handleDateChange}
                allowClear
                format="D MMM, YYYY"
              />
            )}
        </Col>

        <Col xs={24}>
          <Table
            dataSource={data}
            columns={columns}
            loading={loading}
            pagination={pagination}
            onChange={handleTableChange}
            rowKey="id"
             scroll={{x: 900}}
          />
        </Col>
      </Row>
    </RootContainer>
  );
};

const Entry = () => {
  return (
    <Routes>
      <Route path="" element={<UserReport />} />
      <Route path="/details/:id" element={<Details />} />
    </Routes>
  );
};

export default Entry;
